import { useQuery } from "@tanstack/react-query"
import { API } from "config"

const useNetworkCareersReport = (id) => useQuery({ queryKey: [`network-careers-report`, id], queryFn: async () => {
    if(!id) return {}
    const callback = await API.get(`/network/report/careers?career_id=${id}`)
    return callback?.data
}, staleTime: 1000 * 60 * 5, gcTime: 1000 * 60 * 60 * 24})

export default useNetworkCareersReport